import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ShopperAgentSandboxSenderSchema = createEnum([
  "customer",
  "ai",
  "internal",
]);
export type ShopperAgentSandboxSender = z.infer<
  typeof ShopperAgentSandboxSenderSchema
>;

export const ShopperAgentSandboxAttachmentSchema = z.object({
  url: z.string(),
  mimeType: z.string().nullish(),
});
export type ShopperAgentSandboxAttachment = z.infer<
  typeof ShopperAgentSandboxAttachmentSchema
>;

export const ShopperAgentSandboxMessageSchema = z.object({
  sender: ShopperAgentSandboxSenderSchema,
  text: z.string(),
  attachments: z.array(ShopperAgentSandboxAttachmentSchema).optional(),
});
export type ShopperAgentSandboxMessage = z.infer<
  typeof ShopperAgentSandboxMessageSchema
>;

export const ShopperAgentSandboxCustomerMessageSchema =
  ShopperAgentSandboxMessageSchema.extend({ sender: z.literal("customer") });
export type ShopperAgentSandboxCustomerMessage = z.infer<
  typeof ShopperAgentSandboxCustomerMessageSchema
>;
